import _ from 'lodash'
import moment from 'moment'

const state = {
  departureAirport: undefined,
  arrivalAirport: undefined,
  outwardDate: undefined,
  returnDate: undefined,
  classType: undefined,
  travelType: 'two-way',
  travellers: undefined,
  luggageOption: undefined,
  itineraries: [],
  selectedItinerary: undefined,
  updatedSelectedItinerary: undefined,
  loading: false
}

const mutations = {
  changeDepartureAirport (state, newAirport) {
    state.departureAirport = newAirport
  },
  changeArrivalAirport (state, newAirport) {
    state.arrivalAirport = newAirport
  },
  changeOutwardDate (state, newDate) {
    state.outwardDate = newDate
  },
  changeReturnDate (state, newDate) {
    state.returnDate = newDate
  },
  changeClassType (state, newClassType) {
    state.classType = newClassType
  },
  changeTravelType (state, newTravelType) {
    state.travelType = newTravelType
  },
  changeTravellers (state, newTravellers) {
    state.travellers = newTravellers
  },
  changeLuggageOption (state, newLuggageOption) {
    state.luggageOption = newLuggageOption
  },
  resetItineraries (state) {
    state.itineraries = []
  },
  changeItineraries (state, newItineraries) {
    state.itineraries = newItineraries
  },
  changeItinerariesLoading (state, loadingState) {
    state.loading = loadingState
  },
  changeSelectedItinerary (state, newItinerary) {
    state.selectedItinerary = newItinerary
  },
  changeUpdatedSelectedItinerary (state, newItinerary) {
    state.updatedSelectedItinerary = newItinerary
  }
}

const getters = {
  getOutwardFlightDepartureAirportIata (state) {
    let iataCode
    try {
      iataCode = state.departureAirport.iata_code
    } catch (e) {
      iataCode = ''
    }
    return iataCode
  },
  getReturnFlightDepartureAirportIata (state) {
    let iataCode
    try {
      iataCode = state.arrivalAirport.iata_code
    } catch (e) {
      iataCode = ''
    }
    return iataCode
  },
  filteredItineraries (state, getters, rootState) {
    let filteredItineraries = state.itineraries
    // Apply sorting by price
    const priceSortOrder = rootState.fb.searchFilters.priceSortOrder
    filteredItineraries = filtersActions.sortByPrice(filteredItineraries, priceSortOrder)

    const luggageOption = rootState.fb.searchParameters.selectedLuggageOption
    filteredItineraries = filtersActions.luggageFilter(filteredItineraries, luggageOption)

    // Apply schedules filter
    const outwardFlightDepartureDelta = rootState.fb.searchFilters.outwardFlightDepartureDelta
    const returnFlightDepartureDelta = rootState.fb.searchFilters.returnFlightDepartureDelta
    filteredItineraries = filtersActions.schedulesFilter(filteredItineraries, outwardFlightDepartureDelta, returnFlightDepartureDelta)

    // Apply stopover filter
    const selectedStopoverOption = rootState.fb.searchFilters.selectedStopover
    filteredItineraries = filtersActions.stopoverFilter(filteredItineraries, selectedStopoverOption)

    // Apply airline company filter
    const companyList = rootState.fb.searchFilters.selectedAirlineCompanies
    filteredItineraries = filtersActions.airlineCompanyFilter(filteredItineraries, companyList)

    return filteredItineraries
  },
  getPassportRequirements (state) {
    let needPassport = false
    if (state.updatedSelectedItinerary) {
      try {
        if (state.updatedSelectedItinerary.flight_outward.from_place.need_passport) {
          needPassport = true
        }
      } catch (e) {
      }

      try {
        if (state.updatedSelectedItinerary.flight_outward.to_place.need_passport) {
          needPassport = true
        }
      } catch (e) {
      }

      try {
        if (state.updatedSelectedItinerary.flight_return.from_place.need_passport) {
          needPassport = true
        }
      } catch (e) {
      }

      try {
        if (state.updatedSelectedItinerary.flight_return.to_place.need_passport) {
          needPassport = true
        }
      } catch (e) {
      }
    }
    return needPassport
  }
}

const actions = {
  resetStates ({ commit }) {
    commit('changeDepartureAirport', undefined)
    commit('changeArrivalAirport', undefined)
    commit('changeOutwardDate', undefined)
    commit('changeReturnDate', undefined)
    commit('changeClassType', undefined)
    commit('changeTravelType', 'two-way')
    commit('changeTravellers', undefined)
    commit('changeLuggageOption', undefined)
    commit('changeItineraries', [])
    commit('changeUpdatedSelectedItinerary', undefined)
    commit('changeUpdatedSelectedItineraryLoading', false)
    commit('changeItinerariesLoading', false)
  }
}

const filtersActions = {
  sortByPrice (itineraries, order) {
    let sortedItineraries
    if (order === 'increasing') {
      sortedItineraries = _.orderBy(itineraries, ['price'], ['asc'])
    } else {
      sortedItineraries = _.orderBy(itineraries, ['price'], ['desc'])
    }
    return sortedItineraries
  },
  luggageFilter (itineraries, luggageOption) {
    // Verify if luggageOption is default to avoid useless computing
    if (luggageOption === 'no') {
      return itineraries
    }

    const filteredItineraries = []
    for (const groupPrice of itineraries) {
      // remove itineraries in the group price who don't match the rules of the filter
      const filteredGroupPriceItineraries = _.filter(groupPrice.itinerary, (itinerary) => {
        const luggageArray = itinerary.flight_outward.included_luggage
        if (luggageOption === '1') {
          if (luggageArray === 'NO') {
            return false
          }
        } else if (luggageOption === '0') {
          if (luggageArray !== 'NO') {
            return false
          }
        }
        // Same operation is done if itinerary has a return flight
        if (itinerary.flight_return) {
          const luggageArray = itinerary.flight_return.included_luggage
          if (luggageOption === '1') {
            if (luggageArray === 'NO') {
              return false
            }
          } else if (luggageOption === '0') {
            if (luggageArray !== 'NO') {
              return false
            }
          }
        }
        return true
      })

      if (filteredGroupPriceItineraries.length > 0) {
        filteredItineraries.push({
          id: groupPrice.id,
          itinerary: filteredGroupPriceItineraries,
          price: groupPrice.price
        })
      }
    }
    return filteredItineraries
  },
  schedulesFilter (itineraries, outwardFlightDepartureDelta, returnFlightDepartureDelta) {
    if (_.isEqual(outwardFlightDepartureDelta, { begin: 0, end: 24 }) && _.isEqual(returnFlightDepartureDelta, { begin: 0, end: 24 })) {
      return itineraries
    }

    const filteredItineraries = []
    for (const groupPrice of itineraries) {
      // remove itineraries in the group price who don't match the rules of the filter
      const filteredGroupPriceItineraries = _.filter(groupPrice.itinerary, (itinerary) => {
        let isValid = true
        const outwardFlightDepartureMoment = moment(itinerary.flight_outward.begin)
        if (!_.inRange(
          Number(outwardFlightDepartureMoment.format('H')),
          outwardFlightDepartureDelta.begin,
          outwardFlightDepartureDelta.end)
        ) {
          isValid = false
        }
        // Same check is done if itinerary has a return flight
        if (itinerary.flight_return) {
          const returnFlightDepartureMoment = moment(itinerary.flight_return.begin)
          if (!_.inRange(
            Number(returnFlightDepartureMoment.format('H')),
            returnFlightDepartureDelta.begin,
            returnFlightDepartureDelta.end)
          ) {
            isValid = false
          }
        }

        return isValid
      })
      if (filteredGroupPriceItineraries.length > 0) {
        filteredItineraries.push({
          id: groupPrice.id,
          itinerary: filteredGroupPriceItineraries,
          price: groupPrice.price
        })
      }
    }
    return filteredItineraries
  },
  stopoverFilter (itineraries, selectedStopoverOption) {
    if (selectedStopoverOption === 'manystopover') {
      return itineraries
    }

    // Remove itineraries in the group price who don't match the selected stopover option
    const filteredItineraries = []
    for (const groupPrice of itineraries) {
      const filteredGroupPriceItineraries = _.filter(groupPrice.itinerary, (itinerary) => {
        let isValid = true
        const outwardFlightStopover = itinerary.flight_outward.segments.length - 1
        if (selectedStopoverOption === 'direct' && outwardFlightStopover !== 0) {
          isValid = false
        } else if (selectedStopoverOption === 'onestopover' && outwardFlightStopover > 1) {
          isValid = false
        }
        // Same check is done if itinerary has a return flight
        if (itinerary.flight_return) {
          const returnFlightStopover = itinerary.flight_return.segments.length - 1
          if (selectedStopoverOption === 'direct' && returnFlightStopover !== 0) {
            isValid = false
          } else if (selectedStopoverOption === 'onestopover' && returnFlightStopover > 1) {
            isValid = false
          }
        }
        return isValid
      })
      if (filteredGroupPriceItineraries.length > 0) {
        filteredItineraries.push({
          id: groupPrice.id,
          itinerary: filteredGroupPriceItineraries,
          price: groupPrice.price
        })
      }
    }
    return filteredItineraries
  },
  airlineCompanyFilter (itineraries, companyList) {
    const filteredItineraries = []

    for (const groupPrice of itineraries) {
      const filteredGroupPriceItineraries = _.filter(groupPrice.itinerary, (itinerary) => {
        let isValid = true
        for (const segment of itinerary.flight_outward.segments) {
          if (companyList.indexOf(String(segment.marketing_carrier)) === -1) {
            isValid = false
          }
        }
        if (itinerary.flight_return) {
          for (const segment of itinerary.flight_return.segments) {
            if (companyList.indexOf(String(segment.marketing_carrier)) === -1) {
              isValid = false
            }
          }
        }
        return isValid
      })
      if (filteredGroupPriceItineraries.length > 0) {
        filteredItineraries.push({
          id: groupPrice.id,
          itinerary: filteredGroupPriceItineraries,
          price: groupPrice.price
        })
      }
    }
    return filteredItineraries
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
